const commonConfig = {
  hideFlexNavigateBar: ['pricing'], // config-solution 一级页面不显示导航条
  redirectCnIgnore: ['/report-platform/complainant', '/report-platform/confirm'], // 这些路径，登录中国站账号时不会被重定向到中国站
  refererNeedCnMap: [
    'console.intl.cloud.tencent.com',
    'console.intl.cloud.tencent.cn',
    'console.intl.cloud.tencent.com.cn',
    'buy.intl.cloud.tencent.com',
    'buy.intl.cloud.tencent.cn',
    'buy.intl.cloud.tencent.com.cn',
  ], // 从这些referer来源的链接，会进行一次中国站/国际站文档映射。因为这些来源中链接埋的是中国站文档ID。
  cdnDomains: {
    staticDomain: 'static.cloudcachetci.com',
    staticDomainBP: 'static.tencentcloudcs.com',
    staticDomainOld: 'cloudcache.tencent-cloud.com',
    staticintlDomain: 'staticintl.cloudcachetci.com',
    staticintlDomainBP: 'staticintl.tencentcloudcs.com ',
    staticintlDomainOld: 'cloudcache.intl.tencent-cloud.com',
  },
  accessibleCheck: [
    'https://staticintl.cloudcachetci.com/block.png',
    'https://staticintl.tencentcloudcs.com/block.png',
    'https://cloudcache.intl.tencent-cloud.com/block.png',
  ],
  rateLimitConfig: {
    // rateLimit 窗口时间
    rateLimitWindow: 5000,
    // rateLimit 限制值
    rateLimitMax: 200,
    // rateLimit 达到上限时返回的 message
    rateLimitMessage: 'Too many requests, please try again later.',
    // 是否禁用 rateLimit
    disableRateLimit: false,
  },
  tstUins: ['347486423', '632789064', '241923064'],
  grayConfig: {
    homeBannerGrayIpRatio: 0.5,
  },
};

const DOMAINS = {
  com: 'intl.cloud.tencent.com',
  cn: 'intl.cloud.tencent.cn',
  comCn: 'intl.cloud.tencent.com.cn',
};

commonConfig.documentPdfConfig = {
  pdfConvertOn: true,
  pdfDomainConfig: {
    [DOMAINS.cn]: {
      domainPrefix: 'cn',
    },
    [DOMAINS.comCn]: {
      domainPrefix: 'com-cn',
    },
    [DOMAINS.com]: {
      domainPrefix: null,
    },
  },
};

commonConfig.domainFormatConfig = {
  keepUnnecessaryDomainInUrl: false,
};

module.exports = commonConfig;